import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import HeadAdm from "../Header/HeaderAdm/HeaderAdm";
import Loader from "../Loader/Loader";
import { ScrollUpBtn } from "../ScrollUpButton/ScrollUpButton";
import { Conteiner } from "./AdminLayout.Styled";

const AdminLayout = () => {
  return (
    <>
      <HeadAdm />

      <Conteiner>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Conteiner>

      <ScrollUpBtn />
    </>
  );
};
export default AdminLayout;
